import { createContext } from 'react';

const CateringSettingContext = createContext();
CateringSettingContext.displayName = 'CateringSettingContext';

export default CateringSettingContext;
